import { api } from './api';

export type KeyMode = 'live' | 'test';

export interface ApiKeyInfo {
  id: number;
  name: string;
  mode: KeyMode;
  key_prefix: string;
  account: string;
  status: 'active' | 'revoked';
  created_at: string | null;
  last_used_at: string | null;
  revoked_at: string | null;
}

export interface CreatedApiKey extends ApiKeyInfo {
  key: string;
}

export interface ModeUsage {
  calls: number;
  limit: number | null;
  free_limit: number;
  remaining_free: number;
  overage_calls: number;
  rejected_calls: number;
}

export interface AccountUsage {
  account: string;
  period: string;
  period_resets_at: string;
  billing_enabled: boolean;
  live: ModeUsage;
  test: ModeUsage;
  billable_endpoints?: string[];
}

const BASE = '/api/v1/developer';

export const developerService = {
  async listKeys(): Promise<ApiKeyInfo[]> {
    const { data } = await api.get(`${BASE}/keys`);
    return data;
  },
  async createKey(name: string, mode: KeyMode): Promise<CreatedApiKey> {
    const { data } = await api.post(`${BASE}/keys`, { name, mode });
    return data;
  },
  async revokeKey(id: number): Promise<ApiKeyInfo> {
    const { data } = await api.delete(`${BASE}/keys/${id}`);
    return data;
  },
  async usage(): Promise<AccountUsage> {
    const { data } = await api.get(`${BASE}/usage`);
    return data;
  },
};

export const errorMessage = (err: any, fallback = 'Something went wrong. Please try again.'): string => {
  const d = err?.response?.data;
  if (typeof d?.detail === 'string') return d.detail;
  if (typeof d?.error?.message === 'string') return d.error.message;
  if (typeof err?.message === 'string' && !err?.response) return err.message;
  return fallback;
};
